export default __webpack_public_path__ + "static/media/033-wedding-rings.d4409c68.png";